<template>
    <div class="footer-logo-parent">
      <div>
        <svg width="55" height="41" viewBox="0 0 55 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M54.9982 10.4826C54.8873 10.3718 50.8416 11.2401 48.3107 11.9052C44.9115 12.8106 41.0505 14.2701 38.7782 15.545C38.7228 15.5819 38.3164 14.5842 37.873 13.3463C35.7485 7.17545 32.7004 2.50108 29.8923 1.07845C28.5622 0.394848 27.0289 0.320945 25.6988 0.838266C24.3687 1.37406 22.2627 3.38792 20.8402 5.51263C19.5286 7.47106 18.0692 10.3163 16.8129 13.4018L15.917 15.5948C15.3794 14.9907 14.5185 14.5196 13.9477 14.2535C10.2862 12.5464 6.27737 11.545 2.30922 10.854C0.609633 10.5584 0 10.5029 0 10.6323C0 10.6877 0.29558 11.7039 0.646581 12.9233C2.42006 19.1496 6.02244 26.1149 9.68024 30.4752C14.1139 35.7593 19.5637 39.2142 25.0319 40.2119C25.5245 40.2982 25.0258 39.6084 23.5355 38.1427C22.2978 36.9417 20.6536 35.0942 19.8777 34.041C16.6596 29.6734 14.7513 24.3062 15.2796 18.83C15.4736 16.8069 15.9096 15.7611 15.9207 15.6263L16.7575 16.1177C21.1727 18.7043 23.7036 22.0854 25.9574 28.441C26.2345 29.254 26.5486 29.993 26.6225 30.0854C26.7943 30.2997 29.0758 27.8775 29.2679 27.6743C29.5081 27.4212 29.7464 27.1644 29.9829 26.9075C30.0863 26.7948 30.6073 26.2276 30.5759 26.1778C31.9429 28.2618 32.0963 31.1089 31.7342 33.5089C31.47 35.2586 30.8918 36.9621 30.0808 38.5343C29.9127 38.8595 29.7335 39.1773 29.5432 39.4895C29.2476 39.9884 29.0259 40.4318 29.0814 40.4872C29.1183 40.5427 29.8388 40.4133 30.6701 40.1916C40.7383 37.642 49.3101 27.8498 54.1687 13.3094C54.6675 11.8129 55.0369 10.538 55 10.4826H54.9982Z" fill="white"/>
        </svg>
      </div>
      <div class="ml-5">
        <FooterText text="РОССИЙСКАЯ АССОЦИАЦИЯ"></FooterText>
        <FooterText text="ИСКУССТВЕННОГО ИНТЕЛЕКТА"></FooterText>
      </div>
    </div>
</template>
<script>

import FooterText from '@/components/footer/FooterText.vue';

export default{
    name: 'FooterLogo',
    components: {
        FooterText
    }
}

</script>